module.exports = __webpack_public_path__ + "static/media/certificate_ascendo_background.239dc081.png";